import { SelectField } from '@/components';
import {
  AmountSearchBudgetTypeEnumModifier,
  type ProjectSearchFormType,
  baseAmountSearchBudgetTypeEnum,
  type conditionTypeEnum,
  thresholdAmountSearchBudgetTypeEnum,
} from '@/features/search/_models/projects-search';
import type { AmountSearchConditionFieldName } from '@/features/search/_utils/project-amount-search';
import { type FC, useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';

type Props = {
  name:
    | AmountSearchConditionFieldName<'baseAmountType'>
    | AmountSearchConditionFieldName<'targetAmountType'>;
  yearFieldName:
    | AmountSearchConditionFieldName<'baseAmountYear'>
    | AmountSearchConditionFieldName<'targetAmountYear'>;
  conditionType: z.infer<typeof conditionTypeEnum>;
};

export const AmountSearchBudgetTypeField: FC<Props> = ({
  name,
  conditionType,
  yearFieldName,
}) => {
  const { t } = useTranslation();
  const { control } = useFormContext<ProjectSearchFormType>();
  const yearValue = useWatch({ control, name: yearFieldName });

  const options = useMemo(() => {
    const target =
      conditionType === 'threshold'
        ? thresholdAmountSearchBudgetTypeEnum.options
        : baseAmountSearchBudgetTypeEnum.options;
    return target.flatMap((value) => {
      return {
        value,
        label: AmountSearchBudgetTypeEnumModifier[value],
      };
    });
  }, [conditionType]);

  return (
    <SelectField
      name={name}
      label={t('budget-type')}
      wrapperStyle={{ marginBottom: 0 }}
      disabled={!yearValue}
      control={control}
      errors={{}}
      width={160}
      options={options}
    />
  );
};
